export default __webpack_public_path__ + "static/media/Mark-2-Suit-Cycles-06.ab644d12.jpg";